export const ENDPOINTS = {
    usuarios: {
        listar: '/usuarios/listar', // GET, EJ: axios.get('/usuarios/listar')
        crear: '/usuarios/crear', // POST, EJ: axios.post('/register', usuario)
        actualizar: id => `/usuarios/actualizar/${id}`, // PUT, EJ: axios.put(`/usuarios/actualizar/${id}`, usuarioActualizado)
        borrar: id => `/usuarios/borrar/${id}` // DELETE, EJ: axios.delete(`/usuarios/borrar/${id}`) 
    },
    empresas: {
        listar: '/empresas/listar', // GET, EJ: axios.get('/empresas/listar')
        crear: '/empresas/crear', // POST, EJ: axios.post('/empresas/crear', empresa)
        consultar: id => `/empresas/consultar/${id}`, // GET, EJ: axios.get(`/empresas/consultar/${id}`)
        actualizar: id => `/empresas/actualizar/${id}`, // PUT, EJ: axios.put(`/empresas/actualizar/${id}`, empresaActualizada)
        borrar: id => `/empresas/borrar/${id}`, // DELETE, EJ: axios.delete(`/empresas/borrar/${id}`)
    },
    empresasCodigos: {
        listar: id => `/empresas/listarCodigos/${id}`,
        crear: '/sucursalEmpresa/crear', // Este es un endpoint POST, EJ: axios.post('/sucursalEmpresa/crear', codigoCrear)
        actualizar: id => `/sucursalEmpresa/actualizar/${id}`, // Este es un endpoint PUT, EJ: axios.put(`/sucursalEmpresa/actualizar/${idCodigo}`, codigoCrear)
        borrar: id => `/sucursalEmpresa/borrar/${id}` // Este es un endpoint DELETE, EJ: axios.delete(`/sucursalEmpresa/borrar/${id}`)
    },
    hosts: {
        listar: '/host/listar', // GET, EJ: axios.get('/host/listar')
        listarActivos: '/host/listarActivos', // GET, EJ: axios.get('/host/listarActivos')
        crear: '/host/crear', // POST, EJ: axios.post('/host/crear', host)
        consultar: id => `/host/consultar/${id}`, // GET, EJ: axios.get(`/host/consultar/${id}`)
        actualizar: id => `/host/actualizar/${id}`, // PUT, EJ: axios.put(`/host/actualizar/${id}`, hostActualizado)
        borrar: id => `/host/borrar/${id}` // DELETE, EJ: axios.delete(`/host/borrar/${id}`)
    },
    encuestas: {
        listar: '/encuesta/listar', // GET, EJ: axios.get('/encuesta/listar')
        crear: '/encuesta/crear', // POST, EJ: axios.post('/encuesta/crear', encuesta)
        actualizar: id => `/encuesta/actualizar/${id}`, // PUT, EJ: axios.put(`/encuesta/actualizar/${id}`, encuestaActualizada)
        borrar: id => `/encuesta/borrar/${id}` // DELETE, EJ: axios.delete(`/encuesta/borrar/${id}`)
    },
    encuestasPreguntas: {
        listar: id => `/encuesta/consultar/${id}`, // GET, EJ: axios.get(`/encuesta/editar/${id}`)
        crear: '/encuestaPregunta/crear', // POST, EJ: axios.post('/encuestaPregunta/crear', pregunta)
        actualizar: id => `/encuestaPregunta/actualizar/${id}`, // PUT, EJ: axios.put(`/encuestaPregunta/actualizar/${id}`, preguntaActualizada)
        borrar: id => `/encuestaPregunta/borrar/${id}` // DELETE, EJ: axios.delete(`/encuestaPregunta/borrar/${id}`)
    },
    encuestasRespuestas: {
        listar: id => `/encuestaPregunta/consultar/${id}`, // GET, EJ: axios.get(`/encuestaPregunta/editar/${id}`)
        crear: '/encuestaRespuesta/crear', // POST, EJ: axios.post('/encuestaRespuesta/crear', respuesta)
        actualizar: id => `/encuestaRespuesta/actualizar/${id}`, // PUT, EJ: axios.put(`/encuestaRespuesta/actualizar/${id}`, respuestaActualizada)
        borrar: id => `/encuestaRespuesta/borrar/${id}` // DELETE, EJ: axios.delete(`/encuestaRespuesta/borrar/${id}`)
    },
    encuestasTemas: {
        listar: '/encuestaTema/listar', // GET, EJ: axios.get('/encuestaTema/listar')
        crear: '/encuestaTema/crear', // POST, EJ: axios.post('/encuestaTema/crear', tema)
        actualizar: id => `/encuestaTema/actualizar/${id}`, // PUT, EJ: axios.put(`/encuestaTema/actualizar/${id}`, temaActualizado)
        borrar: id => `/encuestaTema/borrar/${id}` // DELETE, EJ: axios.delete(`/encuestaTema/borrar/${id}`)
    },
    encuestasTiposDatos: {
        listar: '/encuestaTipoDato/listar', // GET, EJ: axios.get('/encuestaTipoDato/listar')
        crear: '/encuestaTipoDato/crear', // POST, EJ: axios.post('/encuestaTipoDato/crear', tipoDato)
        actualizar: id => `/encuestaTipoDato/actualizar/${id}`, // PUT, EJ: axios.put(`/encuestaTipoDato/actualizar/${id}`, tipoDatoActualizado)
        borrar: id => `/encuestaTipoDato/borrar/${id}` // DELETE, EJ: axios.delete(`/encuestaTipoDato/borrar/${id}`)
    },
    encuestasTiposPreguntas: {
        listar: '/encuestaTipoPregunta/listar', // GET, EJ: axios.get('/encuestaTipoPregunta/listar')
        crear: '/encuestaTipoPregunta/crear', // POST, EJ: axios.post('/encuestaTipoPregunta/crear', tipoPregunta)
        actualizar: id => `/encuestaTipoPregunta/actualizar/${id}`, // PUT, EJ: axios.put(`/encuestaTipoPregunta/actualizar/${id}`, tipoPreguntaActualizado)
        borrar: id => `/encuestaTipoPregunta/borrar/${id}` // DELETE, EJ: axios.delete(`/encuestaTipoPregunta/borrar/${id}`)
    },
    onroad: {
        listar: '/onroad/listar', // GET, EJ: axios.get('/onroad/listar')
        consultar: id => `/onroad/consultar/${id}`, // GET, EJ: axios.get(`/onroad/consultar/${id}`)
        borrar: id => `/onroad/borrar/${id}` // DELETE, EJ: axios.delete(`/onroad/borrar/${id}`)
    }
};

export default ENDPOINTS;